import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchPromptHistory, type PromptHistoryScope } from './api';

// 計画書「決定待ち事項」#1: 100 で開始 (深さ制限は設けない・キーセットページングのため)
const PAGE_LIMIT = 100;

/**
 * DB 版プロンプト履歴の取得 (全画面モーダル用)。scope 単位でキャッシュし、
 * 「さらに読み込む」で次ページを追記できるよう useInfiniteQuery を使う
 * (features/materials/hooks.ts の useCloudMaterials 等と同じ流儀)。
 */
export function usePromptHistoryQuery(
  scope: PromptHistoryScope,
  opts?: { enabled?: boolean; scenarioId?: string | null },
) {
  const scenarioId = opts?.scenarioId ?? null;
  return useInfiniteQuery({
    // scenarioId はキャッシュキーに含める (絞り込みの有無で結果が変わる)
    queryKey: ['prompt-history', scope, scenarioId],
    queryFn: ({ pageParam }) =>
      fetchPromptHistory(scope, { limit: PAGE_LIMIT, cursor: pageParam ?? null, scenarioId }),
    getNextPageParam: (lastPage) => lastPage.next_cursor ?? undefined,
    initialPageParam: null as string | null,
    staleTime: 5 * 60 * 1000,
    enabled: opts?.enabled ?? true,
    retry: 1,
  });
}
